export const EVENT_MODULE_KEY = 'plugin-ereceptionist';
export const ROOM_BOOKING_MODULE_KEY = 'plugin-roombooking';
export const USER_MODULE_KEY = 'cns-user-management';
export const DEVICE_MODULE_KEY = 'cns-device-management';
export const BUSINESS_NOTIFICATION_MODULE_KEY =
  'cns-business-notification-management';
export const PARKING_MODULE_KEY = 'cns-parking-management';
export const TRUCK_MANAGEMENT_MODULE_KEY = 'cns-truck-management';
export const AUDIT_LOGS_MODULE_KEY = 'cns-audit-logs-management';

export const PLATFORM_TRANSLATIONS_EN = 'PLATFORM_TRANSLATIONS_EN';
export const PLATFORM_TRANSLATIONS_DE = 'PLATFORM_TRANSLATIONS_DE';
export const CUSTOM_SOLUTIONS = 'CUSTOM_SOLUTIONS';
export const ADVANCED_COMPANY_SETTINGS = 'ADVANCED_COMPANY_SETTINGS';
